<template>
  <div class="vx-col w-full mb-base m-auto">
    <vx-card title="Manage Quick Pick ">
      <div class="text-right minus-top" v-if="!quickPickAddEdit">
        <vs-button
          class="mt-4 m-auto gradient-btn"
          @click.prevent="quickPickAddEdit = true"
        >Add Quick Pick</vs-button>
      </div>
      <form class="w-full" v-if="quickPickAddEdit" autocomplete="off">
        <div class="vx-row mb-2">
          <h4 class="ml-5">{{ quickPickIndex ? 'Edit' : 'Add' }} Quick Pick</h4>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col md:w-1/4 form-group w-full">
            <vs-input
              class="w-full"
              label="Name"
              v-validate="'required|alpha_spaces|max:20'"
              name="name"
              v-model="name"
              autocomplete="off"
            />
            <span class="text-danger text-sm">{{ errors.first('name') }}</span>
          </div>
          <div class="vx-col md:w-1/4 form-group w-full">
            <vs-select
              autocomplete
              class="w-full"
              v-validate="'required'"
              label="Status"
              name="status"
              v-model="status"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.name"
                v-for="(item,index) in InOutStatus"
              />
            </vs-select>
            <span class="text-danger text-sm">{{ errors.first('status') }}</span>
          </div>
          <!--  <div class="vx-col md:w-1/3 form-group w-full">
            <vs-input
              class="w-full"
              label="Comment"
              v-validate="'required|alphaNumSpace|max:50'"
              name="comment"
              v-model="comment"
              autocomplete="off"
            />
            <span class="text-danger text-sm">{{ errors.first('comment') }}</span>
          </div>-->
          <!-- <div class="vx-col md:w-1/2 form-group w-full">
            <label>Due Back</label>
            <flat-pickr
              :config="configdateTimePicker"
              class="vs-inputx vs-input--input normal time"
              v-validate="'required'"
              v-model="due_back"
              autocomplete="off"
              name="due_back"
            />
            <span class="text-danger text-sm">{{ errors.first('due_back') }}</span>
          </div>-->
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col w-full">
            <vs-button
              class="mt-1 m-auto gradient-btn"
              @click.prevent="addUpdateQuickPick()"
              :disabled="button_loading"
              id="quickPick-addupdate"
            >{{quickPickIndex ? 'Save' : 'Add' }}</vs-button>
            <vs-button class="mt-1 ml-4 m-auto gradient-btn" @click.prevent="cancelAddEdit()">Cancel</vs-button>
          </div>
        </div>
      </form>
      <div class="mt-5 mb-5">
        <vs-table :data="quickPicks" pagination max-items="15">
          <template slot="thead">
            <vs-th>Name</vs-th>
            <vs-th>Status</vs-th>
            <!--  <vs-th>Comment</vs-th> -->
            <!-- <vs-th>Due Back</vs-th> -->
            <vs-th style="width: 15%;">Action</vs-th>
          </template>

          <template slot-scope="{data}">
            <draggable @change="changeOrder()" v-model="quickPicks" tag="tbody">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>{{ tr.name }}</vs-td>
                <vs-td>
                  <span v-if="tr.status == 'IN'">In</span>
                  <span v-if="tr.status == 'OUT'">Out</span>
                  <span v-if="tr.status == 'CIN'">Clock In</span>
                  <span v-if="tr.status == 'COUT'">Clock Out</span>
                  <span v-if="tr.status == 'BI'">Break</span>
                </vs-td>
                <!--  <vs-td>{{ tr.comment }}</vs-td> -->
                <!-- <vs-td>{{ tr.due_back}}</vs-td> -->
                <vs-td>
                  <vs-button
                    color="#F4B400"
                    type="filled"
                    class="mr-2 mb-2 edit-user float-left"
                    icon-pack="feather"
                    icon="icon-edit-2"
                    size="small"
                    title="Edit Quick Pick"
                    @click.stop="editQuickPick(data[indextr])"
                  ></vs-button>
                  <vs-button
                    color="#DB4437"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-trash-2"
                    size="small"
                    title="Delete Quick Pick"
                    @click.stop="confirmDelete(data[indextr].id)"
                  ></vs-button>
                </vs-td>
              </vs-tr>
            </draggable>
          </template>
        </vs-table>
      </div>
    </vx-card>
    <!-- <vs-popup class="holamundo" title="Vehicle Detail's" :active.sync="vehicleDetailPopup">
      <div class="overflow-auto mb-5">
        <table class="application-detail" v-if="vehicleViewData">
          <tr>
            <th>Name</th>
            <td>{{ vehicleViewData.name }}</td>
          </tr>
          <tr>
            <th>Status</th>
            <td>{{ vehicleViewData.status }}</td>
          </tr>
          <tr>
            <th>Comment</th>
            <td>{{ vehicleViewData.comment }}</td>
          </tr>
          <tr>
            <th>Due Back</th>
            <td>{{ vehicleViewData.due_back }}</td>
          </tr>
        </table>
      </div>
    </vs-popup>-->
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { Validator } from "vee-validate";
import timeZone from "@/mixins/timezone.js";
import Datepicker from "vuejs-datepicker";

Validator.extend("alphaNumSpace", {
  validate: value => {
    var strongRegex = new RegExp("^[a-zA-Z0-9 ]*$");
    return strongRegex.test(value);
  }
});

const dict = {
  custom: {
    name: {
      required: "Please enter Name",
      alpha_spaces: "Only alphabetic characters and space allowed",
      max: "Name should not be greater than 20 characters"
    },
    status: {
      required: "Please select status"
    },
    /*  comment:{
      required: "Please enter comment",
      alphaNumSpace: "Only alphabetic characters , numeric value and space allowed",
      max: "Comment should not be greater than 50 characters"
    }, */
    due_back: {
      required: "Please select due back time"
    }
  }
};
// register custom messages
Validator.localize("en", dict);

export default {
  components: {
    Datepicker,
    draggable
  },
  data() {
    return {
      deleteIndex: 0,
      quickPickAddEdit: false,
      status: null,
      quickPicks: [],
      name: null,
      // comment:null,
      due_back: null,
      configdateTimePicker: {
        enableTime: true,
        noCalendar: true,
        //dateFormat: "H:i",
        time_24hr: false
      },
      InOutStatus: [
        { value: "IN", name: "In" },
        { value: "OUT", name: "Out" },
        { value: "CIN", name: "Clock In" },
        { value: "COUT", name: "Clock Out" },
        { value: "BI", name: "Break" }
      ]
    };
  },
  created() {
    if (
      this.$store.state.uInfo.role !== "CA" &&
      this.$store.state.uInfo.role !== "HR"
    ) {
      history.back();
    }
  },
  mounted() {
    this.getQuickPicks();
  },
  computed: {
    breadcrumb() {
      let title = "Manage Quick Pick";
      if (this.quickPickAddEdit) {
        if (this.quickPickIndex) {
          return title + " / Edit Quick Pic";
        } else {
          return title + " / Add Quick Pic";
        }
      }
      return title;
    }
  },

  methods: {
    changeOrder() {
      var new_order = [];
      this.quickPicks.forEach(function(value, i) {
        console.log("id", value);

        var obj = { quickPickId: value.id, order: i + 1 };
        new_order.push(obj);
      });
      console.log("new order", new_order);
      let input = {
        id: this.$store.state.uInfo.organization,
        new_order: new_order
      };

      this.axios
        .put("quickPicks/editSortingOrder", input)
        .then(response => {
          this.$vs.loading.close();
        })
        .catch(e => {
          this.showError(e);
          this.$vs.loading.close();
        });
      console.log("new order", new_order);
    },
    getQuickPicks() {
      this.$vs.loading({ color: "primary" });

      let url = "quickPicks?from_admin=org";
      this.axios
        .get(url)
        .then(response => {
          let data = response.data.data;
          this.quickPicks = data;
          console.log("quickPicks", response);
          this.$vs.loading.close();
        })
        .catch(e => {
          this.showError(e);
        });
    },
    confirmDelete(index) {
      this.deleteIndex = index;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to delete this quick pick ?",
        acceptText: "Delete",
        accept: this.deleteQuickPics
      });
    },
    deleteQuickPics() {
      let input = {
        data: {
          id: this.deleteIndex
        }
      };
      this.$vs.loading({ color: "primary" });
      this.axios
        .delete("quickPicks", input)
        .then(response => {
          this.$vs.loading.close();
          let text = "Quick pick deleted successfully!!!";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
          this.deleteIndex = 0;
          this.getQuickPicks();
        })
        .catch(e => {
          this.deleteIndex = 0;
          this.showError(e);
        });
    },

    editQuickPick(quickPick) {
      this.quickPickAddEdit = true;
      this.quickPickIndex = quickPick.id;
      this.status = quickPick.status;
      this.name = quickPick.name;
      // this.comment = quickPick.comment;
      this.due_back = quickPick.due_back;
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    addUpdateQuickPick() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.button_loader(true, "#quickPick-addupdate");
          this.axios.defaults.headers.common[
            "x-auth"
          ] = this.$store.state.authToken;
          if (this.quickPickIndex) {
            this.updateQuickPick();
          } else {
            this.addQuickPick();
          }
        }
      });
    },
    addQuickPick() {
      let input = {
        status: this.status,
        name: this.name,
        //  comment: this.comment,
        due_back: this.due_back
      };
      this.axios
        .post("quickPicks", input)
        .then(response => {
          this.button_loader(false, "#quickPick-addupdate");
          let text = "Quick pick created successfully!!!";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
          this.cancelAddEdit();
        })
        .catch(e => {
          this.showError(e, "#quickPick-addupdate");
        });
    },
    updateQuickPick() {
      let input = {
        id: this.quickPickIndex,
        status: this.status,
        name: this.name,
        //  comment: this.comment,
        due_back: this.due_back
      };
      this.axios
        .put("quickPicks", input)
        .then(response => {
          this.button_loader(false, "#quickPick-addupdate");
          let text = "Quick pick updated successfully!!!";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
          this.cancelAddEdit();
        })
        .catch(e => {
          this.showError(e, "#quickPick-addupdate");
        });
    },
    cancelAddEdit() {
      this.quickPickAddEdit = false;
      this.status = null;
      this.name = null;
      // this.comment = null;
      this.due_back = null;
      this.getQuickPicks();
    }
  }
};
</script>
<style>
.code-border {
  border: 1px solid;
}
.minus-top {
  margin-top: -58px;
}
</style>

		